<template>
    <div id="HelpMenu" class="menu menu-box-right bg-gray" data-menu-width="100%" data-menu-effect="menu-over">
        <div class="position-relative">
            <button @click="pauseAllVid()" class="close-menu"><i class="fa fa-times text-white font-26"></i></button>
            <div class="card mb-3" data-card-height="60">
                <div class="card-top">
                    <div class="page-title page-title-small">
                        <h2 class="text-center" v-if="isKarnegasht==false">{{title}}</h2>
                        <h2 class="text-center" v-if="isKarnegasht==true">راهنمای اپلیکیشن کارنگاشت</h2>
                    </div>
                </div>
                <div class="card-overlay bg-highlight opacity-95"></div>
                <div class="card-overlay dark-mode-tint"></div>
            </div>
            <div class="card card-style">
                <div class="px-3 pt-3">
                    <div class="w-100 search-box rounded-m position-relative">
                        <i class="fa fa-search pr-3"></i>
                        <input class="border-0" placeholder="جستجو ..." type="text" v-model="text" @keyup="getEducationList()">
                    </div>
                </div>

                <div class="content mt-0 pb-2">
                    <!--<div class="list-group list-custom-small list-icon-0 mt-3 border-b">
                        <a class="list-group-div" href="https://taskinoapp.com/support.html?device=mobile" target="_blank">
                            <i class="fa font-14 fa-headphones color-red1-dark" style="margin-right:0!important"></i>
                            <span class="font-14">پشتیبانی هوشمند</span>
                            <i class="fa fa-angle-down line-height-xl"></i>
                        </a>
                    </div>-->

                    <div v-for="item in EducationList" :key="item.seq">
                        <div class="list-group list-custom-small list-icon-0 mt-3 border-b">
                            <div data-toggle="collapse" :data-target="'#collapse-'+item.seq" class="collapsed list-group-div" aria-expanded="false">
                                <i class="fa font-14 fa-info-circle color-magenta1-light"></i>
                                <span class="font-14">{{item.title}}</span>
                                <i class="fa fa-angle-down line-height-xl"></i>
                            </div>
                        </div>
                        <div class="collapse border-b pb-3" :id="'collapse-'+item.seq" style="">
                            <div class="d-flex justify-content-center">
                                <video v-if="isKarnegasht==false" class="responsive-video" controls id="video0" preload="none" poster="/assets/images/taskAppHelpVideoPoster.jpg">
                                    <source :src="item.fileName" type="video/mp4">
                                </video>

                                <video v-if="isKarnegasht==true" class="responsive-video" controls id="video0" preload="none" poster="/assets/images/karnegashtHelpVideoPoster.jpg">
                                    <source :src="item.fileName" type="video/mp4">
                                </video>
                            </div>
                            <a :href="item.fileName" download target="_blank" class="btn btn-m btn-full bg-highlight rounded-m font-900 mt-3">دانلود</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Help-Menu",
        props: ['title', "keyEn"],

        data() {
            return {
                keyEnVal: this.keyEn,
                text: "",
                EduList: []
            };
        },
        methods: {
            getEducationList() {
                this.$http
                    .get("Account/GetEducationList?keyEn=" + this.keyEn + "&text=" + this.text)
                    .then((data) => {
                        var res = data.data;
                        this.EduList = res;
                    });

            },
            pauseAllVid() {
                document.querySelectorAll('video').forEach(vid => vid.pause());
            },
        },
        computed: {
            EducationList() {
                return this.EduList;
            },
        },
        created() {
            this.getEducationList();
        }

    };
</script>